/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Configuration } from "./configuration";
import type { RequestArgs } from "./base";
import type { AxiosInstance, AxiosResponse } from "axios";
import { RequiredError } from "./base";

export type AssignOptionsRequired = {
  unassign: boolean;
  unassignChangeTracker: boolean;
  isNew: boolean;
  filter: FilterVarsType;
};

const defaultFilter: FilterVarsType = (a, b, c, d) => true;

export type AssignOptions = Partial<AssignOptionsRequired>;

export function getAssignOptions(a?: AssignOptions): AssignOptionsRequired {
  const assignOptions = {} as AssignOptions;
  if (a) Object.assign(assignOptions, a);
  if (assignOptions.unassign === undefined || assignOptions.unassign === null)
    assignOptions.unassign = true;
  if (
    assignOptions.unassignChangeTracker === undefined ||
    assignOptions.unassignChangeTracker === null
  )
    assignOptions.unassignChangeTracker = assignOptions.unassign;
  if (assignOptions.isNew === undefined || assignOptions.isNew === null)
    assignOptions.isNew = false;
  if (!assignOptions.filter) assignOptions.filter = defaultFilter;
  return assignOptions as AssignOptionsRequired;
}

export type PropertyMeta<T extends MetaTypeBase<any>> = {
  propertyType: T;
  propertyName: string;
  isArray: boolean;
  required: boolean;
  isPrimary: boolean;
  inheritedFrom: PropertyMeta<any>;
};

export type MetaTypeBase<T> = {
  typeName: string;
  isEnum: boolean;
  isModel: boolean;
} & T;

export type EnumMetaType<T_Enum, T_Enum_Value> = MetaTypeBase<T_Enum_Value> & {
  enum: T_Enum;
  isEnum: true;
};

export type TypeDefineType = { [key: string]: MetaTypeBase<any> };

export type MetaType<T extends TypeDefineType> = MetaTypeBase<T> & {
  properties: PropertyMeta<any>[];
  interfaces: MetaType<any>[];
  isModel: true;
};

export const MetaTypesBase = {
  string: typeMetaBase<string>("string", "STRING"),
  number: typeMetaBase<number>("number", 1),
  currency: typeMetaBase<number>("currency", 0),
  boolean: typeMetaBase<boolean>("number", false),
  Date: typeMetaBase<Date>("number", new Date()),
  // Calendar date with no time of day (backend LocalDate).
  LocalDate: typeMetaBase<Date>("number", new Date()),
};

export type FilterVarsType = (
  property: PropertyMeta<any>,
  model: MetaType<any>,
  propertyValue: any,
  modelValue: any,
) => boolean;

export function propertyMeta<T extends MetaTypeBase<any>>(
  propertyName: string,
  isArray: boolean,
  required: boolean,
  isPrimary: boolean,
  propertyType: T,
): PropertyMeta<T> {
  return {
    propertyType,
    isArray,
    required,
    isPrimary,
    propertyName,
  } as PropertyMeta<T>;
}

function typeMetaBase<T>(typeName: string, typeDefine: T): MetaTypeBase<T> {
  return {
    ...typeDefine,
    typeName,
    isEnum: false,
    isModel: false,
  } as MetaTypeBase<T>;
}

export function typeMeta<T extends TypeDefineType>(
  typeName: string,
  typeDefine: T,
): MetaType<T> {
  const properties = Object.values(typeDefine);
  return {
    ...typeDefine,
    typeName,
    properties,
    interfaces: [],
    isEnum: false,
    isModel: true,
  } as MetaType<T>;
}

export function typeMetaEnum<T_Enum, T_Enum_Value>(
  typeName: string,
  enumType: T_Enum,
): EnumMetaType<T_Enum, T_Enum_Value> {
  return {
    typeName,
    isEnum: true,
    isModel: false,
    enum: enumType,
  } as EnumMetaType<T_Enum, T_Enum_Value>;
}

/**
 *
 * @export
 */
export const DUMMY_BASE_URL = "https://example.com";

/**
 *
 * @throws {RequiredError}
 * @export
 */
export const assertParamExists = function (
  functionName: string,
  paramName: string,
  paramValue: unknown,
) {
  if (paramValue === null || paramValue === undefined) {
    throw new RequiredError(
      paramName,
      `Required parameter ${paramName} was null or undefined when calling ${functionName}.`,
    );
  }
};

/**
 *
 * @export
 */
export const setApiKeyToObject = async function (
  object: any,
  keyParamName: string,
  configuration?: Configuration,
) {
  if (configuration && configuration.apiKey) {
    const localVarApiKeyValue =
      typeof configuration.apiKey === "function"
        ? await configuration.apiKey(keyParamName)
        : await configuration.apiKey;
    object[keyParamName] = localVarApiKeyValue;
  }
};

/**
 *
 * @export
 */
export const setBasicAuthToObject = function (
  object: any,
  configuration?: Configuration,
) {
  if (configuration && (configuration.username || configuration.password)) {
    object["auth"] = {
      username: configuration.username,
      password: configuration.password,
    };
  }
};

/**
 *
 * @export
 */
export const setBearerAuthToObject = async function (
  object: any,
  configuration?: Configuration,
) {
  if (configuration && configuration.accessToken) {
    const accessToken =
      typeof configuration.accessToken === "function"
        ? await configuration.accessToken()
        : await configuration.accessToken;
    object["Authorization"] = "Bearer " + accessToken;
  }
};

/**
 *
 * @export
 */
export const setOAuthToObject = async function (
  object: any,
  name: string,
  scopes: string[],
  configuration?: Configuration,
) {
  if (configuration && configuration.accessToken) {
    const localVarAccessTokenValue =
      typeof configuration.accessToken === "function"
        ? await configuration.accessToken(name, scopes)
        : await configuration.accessToken;
    object["Authorization"] = "Bearer " + localVarAccessTokenValue;
  }
};

function setFlattenedQueryParams(
  urlSearchParams: URLSearchParams,
  parameter: any,
  key: string = "",
): void {
  if (parameter == null) return;
  if (typeof parameter === "object") {
    if (Array.isArray(parameter)) {
      (parameter as any[]).forEach((item) =>
        setFlattenedQueryParams(urlSearchParams, item, key),
      );
    } else {
      Object.keys(parameter).forEach((currentKey) =>
        setFlattenedQueryParams(
          urlSearchParams,
          parameter[currentKey],
          `${key}${key !== "" ? "." : ""}${currentKey}`,
        ),
      );
    }
  } else {
    if (urlSearchParams.has(key)) {
      urlSearchParams.append(key, parameter);
    } else {
      urlSearchParams.set(key, parameter);
    }
  }
}

/**
 *
 * @export
 */
export const setSearchParams = function (url: URL, ...objects: any[]) {
  const searchParams = new URLSearchParams(url.search);
  setFlattenedQueryParams(searchParams, objects);
  url.search = searchParams.toString();
};

/**
 *
 * @export
 */
export const serializeDataIfNeeded = function (
  value: any,
  requestOptions: any,
  configuration?: Configuration,
) {
  const nonString = typeof value !== "string";
  const needsSerialization =
    nonString && configuration && configuration.isJsonMime
      ? configuration.isJsonMime(requestOptions.headers["Content-Type"])
      : nonString;
  return needsSerialization
    ? JSON.stringify(value !== undefined ? value : {})
    : value || "";
};

/**
 *
 * @export
 */
export const toPathString = function (url: URL) {
  return url.pathname + url.search + url.hash;
};

/**
 *
 * @export
 */
export const createRequestFunction = function <
  T = unknown,
  R = AxiosResponse<T>,
>(
  axiosArgs: RequestArgs,
  globalAxios: AxiosInstance,
  BASE_PATH: string,
  configuration?: Configuration,
) {
  return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
    const axiosRequestArgs = {
      ...axiosArgs.options,
      url:
        (axios.defaults.baseURL ? "" : (configuration?.basePath ?? basePath)) +
        axiosArgs.url,
    };
    return axios.request<T, R>(axiosRequestArgs);
  };
};
